module.exports = __webpack_public_path__ + "img/vertical_7_2_7042.bfa99933.png";